import getQueryParams from '@/utilities/getters/getQueryParams';

export const GAME_LAUNCH_SOURCE = {
  SHORT_LINK: 'short_link',
  FULL_URL: 'full_url',
  RECENTLY_PLAYED_IN_GAME: 'recently_played_in_game',
  UNKNOWN: 'unknown',
} as const;

export type GameLaunchSourceValue =
  (typeof GAME_LAUNCH_SOURCE)[keyof typeof GAME_LAUNCH_SOURCE];

export const PENDING_GAME_LAUNCH_SOURCE_STORAGE_KEY = 'pendingGameLaunchSource';

export type ResolveGameLaunchSourceInput = {
  isShortLinkLaunch: boolean;
  hasQueryParamLaunch?: boolean;
  pendingLaunchSource?: string | null;
};

export const resolveGameLaunchSource = ({
  isShortLinkLaunch,
  hasQueryParamLaunch,
  pendingLaunchSource,
}: ResolveGameLaunchSourceInput): string => {
  if (pendingLaunchSource) {
    return pendingLaunchSource;
  }

  if (isShortLinkLaunch) {
    return GAME_LAUNCH_SOURCE.SHORT_LINK;
  }

  if (hasQueryParamLaunch) {
    return GAME_LAUNCH_SOURCE.FULL_URL;
  }

  return GAME_LAUNCH_SOURCE.UNKNOWN;
};

export const setPendingGameLaunchSource = (source: string): void => {
  if (typeof sessionStorage === 'undefined') {
    return;
  }

  sessionStorage.setItem(PENDING_GAME_LAUNCH_SOURCE_STORAGE_KEY, source);
};

export const consumePendingGameLaunchSource = (): string | null => {
  if (typeof sessionStorage === 'undefined') {
    return null;
  }

  const value = sessionStorage.getItem(PENDING_GAME_LAUNCH_SOURCE_STORAGE_KEY);

  if (value) {
    sessionStorage.removeItem(PENDING_GAME_LAUNCH_SOURCE_STORAGE_KEY);
  }

  return value;
};

const hasQueryParamLaunch = (): boolean =>
  Boolean(getQueryParams('gameUid') || getQueryParams('providerRef'));

export const getGameLaunchSourceForCurrentSession = (
  isShortLinkLaunch: boolean,
): string =>
  resolveGameLaunchSource({
    isShortLinkLaunch,
    hasQueryParamLaunch: hasQueryParamLaunch(),
    pendingLaunchSource: consumePendingGameLaunchSource(),
  });
